import { Stack, Text } from '@fluentui/react';
import { SignInButton } from './SignInButton';



export const SignInPage = () => {
  return (
    <Stack
      tokens={{ childrenGap: 10 }}
      verticalAlign="center"
      horizontalAlign="center"
      styles={{ root: { height: '100vh' } }}
    >
      <Text>You are not signed in! Please sign in.</Text>
      <SignInButton />
    </Stack>
  );
};

export default SignInPage;
